<nav *ngIf="items.length > 1" class="uc-breadcrumb" [attr.aria-label]="'unifiedShell.breadcrumb.ariaLabel' | translate">
  <ol class="uc-breadcrumb__list">
    <li *ngFor="let item of items; let last = last" class="uc-breadcrumb__item">
      <ng-template #label>{{ item.labelKey ? (item.labelKey | translate) : dataText(item) }}</ng-template>
      <a *ngIf="!last && item.url; else plain" class="uc-breadcrumb__link" [routerLink]="item.url"
        [attr.title]="item.labelKey ? null : dataText(item)">
        <ng-container *ngTemplateOutlet="label"></ng-container>
      </a>
      <ng-template #plain>
        <span class="uc-breadcrumb__text" [class.uc-breadcrumb__current]="last" [attr.aria-current]="last ? 'page' : null"
          [attr.title]="item.labelKey ? null : dataText(item)">
          <ng-container *ngTemplateOutlet="label"></ng-container>
        </span>
      </ng-template>
      <span *ngIf="!last" class="uc-breadcrumb__separator" aria-hidden="true"></span>
    </li>
  </ol>
</nav>
